import { useEffect } from 'react';
import confetti from 'canvas-confetti';

/**
 * Success Celebration Component
 * Triggers confetti animation on mount
 */
const SuccessCelebration = ({
  type = 'default', // default, firework, stars, emoji
  duration = 3000,
  particleCount = 100,
  spread = 70,
  colors = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6']
}) => {
  useEffect(() => {
    const runConfetti = () => {
      switch (type) {
        case 'firework':
          fireConfetti();
          break;
        case 'stars':
          starsConfetti();
          break;
        case 'emoji':
          emojiConfetti();
          break;
        case 'default':
        default:
          defaultConfetti();
          break;
      }
    };

    // Default confetti from bottom
    const defaultConfetti = () => {
      confetti({
        particleCount,
        spread,
        origin: { y: 0.7 },
        colors,
        ticks: 200,
        gravity: 1,
        decay: 0.94,
        startVelocity: 30
      });
    };

    // Firework explosion
    const fireConfetti = () => {
      const count = 200;
      const defaults = {
        origin: { y: 0.7 },
        colors
      };

      function fire(particleRatio, opts) {
        confetti({
          ...defaults,
          ...opts,
          particleCount: Math.floor(count * particleRatio)
        });
      }

      fire(0.25, {
        spread: 26,
        startVelocity: 55
      });

      fire(0.2, {
        spread: 60
      });

      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8
      });

      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2
      });

      fire(0.1, {
        spread: 120,
        startVelocity: 45
      });
    };

    // Stars from sides
    const starsConfetti = () => {
      const end = Date.now() + duration;

      const colors = ['#FFD700', '#FFA500', '#FF69B4'];

      (function frame() {
        confetti({
          particleCount: 2,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          colors,
          shapes: ['star'],
          scalar: 1.2
        });

        confetti({
          particleCount: 2,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          colors,
          shapes: ['star'],
          scalar: 1.2
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();
    };

    // Emoji celebration
    const emojiConfetti = () => {
      const scalar = 2;
      const emoji = confetti.shapeFromText({ text: '🎉', scalar });

      const defaults = {
        spread: 360,
        ticks: 60,
        gravity: 0,
        decay: 0.96,
        startVelocity: 20,
        shapes: [emoji],
        scalar
      };

      function shoot() {
        confetti({
          ...defaults,
          particleCount: 30
        });

        confetti({
          ...defaults,
          particleCount: 5,
          flat: true
        });

        confetti({
          ...defaults,
          particleCount: 15,
          scalar: scalar / 2,
          shapes: ['circle']
        });
      }

      setTimeout(shoot, 0);
      setTimeout(shoot, 100);
      setTimeout(shoot, 200);
    };

    runConfetti();
  }, [type, duration, particleCount, spread, colors]);

  return null;
};

export default SuccessCelebration;
